<template>
  <div>
    <div class="title-header d-flex align-center mx-2">
      <div>{{ construction_site.name }}</div>
      <div class="ml-auto">
        <v-btn
          @click="
            $router.push({
              name: 'ConstructionSiteEdit',
              params: { id: $route.params.id },
            })
          "
        >
          <v-icon>
            mdi-cog
          </v-icon>
        </v-btn>
      </div>
    </div>
    <l-map
      :crs="crs"
      :center="center"
      :bounds="bounds"
      style="width: 100%; height: calc(100vh - 112px); z-index: 99;"
      :options="{
        contextmenu: true,
        contextmenuItems: [
          {
            text: 'この地点にマーカーを作成する',
            index: 0,
            callback: openDialog,
          },
        ],
      }"
    >
      <l-image-overlay :url="mapURL" :bounds="bounds"></l-image-overlay>
      <l-marker
        v-for="m in markers"
        :key="m.id"
        :lat-lng="[m.lat, m.lng]"
        @click="
          $router.push({
            name: 'MeasureGraph',
            params: { id: m.measure_id },
          })
        "
        :options="{
          marker_id: m.id,
          contextmenu: true,
          contextmenuItems: [
            {
              text: 'このマーカーを削除する',
              index: 0,
              callback: deleteMarker,
            },
          ],
          contextmenuInheritItems: false,
        }"
      >
        <l-icon :icon-anchor="[16, 37]">
          <div class="header">
            <span>{{ m.name }}</span>
          </div>
          <div class="markerIcon">
            <span>{{ m.value }}{{ $sanitize(m.value_unit) }}</span>
          </div>
        </l-icon>
      </l-marker>
    </l-map>

    <v-dialog v-model="dialog" class="dialog" max-width="600">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          マーカーの作成
        </v-card-title>

        <v-card-text>
          <v-select
            label="計測を選択"
            v-model="selected"
            :items="unusedMeasures"
            item-text="name"
            item-value="id"
          ></v-select>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="clickCreate">
            作成
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import api from "@/api";
import { CRS } from "leaflet";
import { LMap, LImageOverlay, LMarker, LIcon } from "vue2-leaflet";

export default {
  name: "ConstructionSiteDetail",
  components: { LMap, LImageOverlay, LMarker, LIcon },
  data() {
    return {
      construction_site: {},
      measures: [],
      selected: null,
      newMarker: null,
      crs: CRS.Simple,
      center: [0, 0],
      bounds: [
        [0, 0],
        [1000, 1000],
      ],
      mapURL: "",
      dialog: false,
    };
  },
  computed: {
    markers() {
      return this.construction_site.markers;
    },
    unusedMeasures() {
      return this.measures.filter((measure) => {
        return !this.markers.map((m) => m.measure_id).includes(measure.id);
      });
    },
  },
  async created() {
    this.construction_site = await api.construction_sites.find(
      this.$route.params.id
    );
    this.mapURL = this.construction_site.image_url;
    const mapImage = new Image();
    mapImage.src = this.mapURL;
    mapImage.onload = () => {
      this.center = [mapImage.width / 2, mapImage.height / 2];
      this.bounds = [[0, 0], [mapImage.height, mapImage.width]]
    };

    this.measures = await api.measures.list();
    this.measures = this.measures.filter((measure) => {
      return measure.site_group_id === this.construction_site.site_group_id;
    });
  },
  methods: {
    deleteMarker(event) {
      const id = this.$route.params.id;
      const marker_id = event.relatedTarget.options.marker_id;
      api.construction_sites.delete_marker(id, marker_id).then(() => {
        let index = this.construction_site.markers.findIndex(
          (m) => m.id === marker_id
        );
        this.construction_site.markers.splice(index, 1);
      });
    },
    openDialog(event) {
      this.newMarker = {
        lat: event.latlng.lat,
        lng: event.latlng.lng,
      };
      this.dialog = true;
    },
    clickCreate() {
      const id = this.$route.params.id;
      this.newMarker = Object.assign(
        { measure_id: this.selected },
        this.newMarker
      );

      api.construction_sites.create_marker(id, this.newMarker).then((resp) => {
        this.construction_site.markers.push(resp);
      });

      this.dialog = false;
    },
  },
};
</script>
<style scoped>
.header {
  font-weight: bold;
  font-size: 10px;
  width: 200px;
}

.header span {
  background-color: #fff;
  font-size: 1rem;
}

.title-header {
  height: 48px;
}

.markerIcon {
  background-color: #f0f0f2;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 1px solid red;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.markerIcon > span {
  font-size: 1rem;
  font-weight: bold;
}

.dialog {
  z-index: 999;
}
</style>
